"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ApiClient_1 = __importDefault(require("../utils/ApiClient"));
var moment_1 = __importDefault(require("moment"));
var FirmRepository = /** @class */ (function () {
    function FirmRepository() {
    }
    FirmRepository.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firms';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.findByHost = function (host) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.post('/firm_host', {
                        host: host
                    })];
            });
        });
    };
    FirmRepository.findByName = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.post('/firm_webshop', {
                        name: name
                    })];
            });
        });
    };
    FirmRepository.findByAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ApiClient_1.default.post('/firms/store-locator', __assign(__assign({}, address), { country: address.country.name }))];
            });
        });
    };
    // @TODO when the back will have a REST compliant endpoint the id will be set within the url
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    FirmRepository.getOne = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getCashRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firms_cashregister';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getAnnouncements = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/announcements';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getNewsFeed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/newsfeed';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getLastModification = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/lastmodification';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getReservations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/reservations';
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getMobileAppStoreSettings = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/".concat(id, "/mobile-app-store-settings");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    /**
     * @TODO will have to refactor this in order to have a "get" with url parameters...
     * @param date
     * @param deliveryMethod
     * @param products
     * @param categories
     * @param pickupPointId
     */
    FirmRepository.getTimeslots = function (date, deliveryMethod, products, categories, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/timeslots';
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        date: (0, moment_1.default)(date).format('YYYY-MM-DD'),
                        products: products,
                        categories: categories,
                        delivery_method: deliveryMethod,
                        firm_pickup_point_id: pickupPointId
                    })];
            });
        });
    };
    /**
     * @TODO will have to refactor this in order to have a "get" with url parameters
     * @param timeslotsId
     * @param date
     * @param deliveryMethod
     * @param products
     * @param categories
     * @param pickupPointId
     */
    FirmRepository.getTimeIntervals = function (timeslotsId, date, deliveryMethod, products, categories, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/timeslots/".concat(timeslotsId);
                return [2 /*return*/, ApiClient_1.default.post(url, {
                        date: (0, moment_1.default)(date).format('YYYY-MM-DD'),
                        products: products,
                        categories: categories,
                        delivery_method: deliveryMethod,
                        firm_pickup_point_id: pickupPointId
                    })];
            });
        });
    };
    FirmRepository.checkPassword = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = '/firm/checkpassword';
                return [2 /*return*/, ApiClient_1.default.post(url, { password: password })];
            });
        });
    };
    FirmRepository.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/".concat(id);
                return [2 /*return*/, ApiClient_1.default.delete(url)];
            });
        });
    };
    FirmRepository.create = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/".concat(entity.id);
                return [2 /*return*/, ApiClient_1.default.post(url, entity)];
            });
        });
    };
    FirmRepository.partialUpdate = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/".concat(entity.id);
                return [2 /*return*/, ApiClient_1.default.patch(url, entity)];
            });
        });
    };
    FirmRepository.update = function (entity) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/firm/".concat(entity.id);
                return [2 /*return*/, ApiClient_1.default.put(url, entity)];
            });
        });
    };
    FirmRepository.getCustomLinks = function (firmId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/firm/".concat(firmId, "/custom-links");
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    FirmRepository.getGuestFields = function (deliveryMethod, pickupPointId) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = "/storefront/delivery-methods/".concat(deliveryMethod, "/guest-fields");
                if (pickupPointId) {
                    url += "?pickupPointId=".concat(pickupPointId.toString());
                }
                return [2 /*return*/, ApiClient_1.default.get(url)];
            });
        });
    };
    return FirmRepository;
}());
exports.default = FirmRepository;
